// removed by extract-text-webpack-plugin
module.exports = {"footer":"_1d63","container":"_2V-q","inner":"_6t0z","lists":"_1a0U","list":"O-rt","socialLinks":"tqJx","hotline":"_2hFq","contactus":"fJSn","facebook":"_2Ixt","instagram":"_1K0y","twitter":"_3B1z","youtube":"_142l","pinterest":"_3EfC","tumblr":"_38fc","googlePlus":"_2-TT","rss":"_2d03","mobileAppContainer":"_30ey","mobileApp":"_14za","mobile":"VHWE","title":"_1vUJ","subtitle":"ko-u","stores":"_2F4l","partners":"_1BqQ","sunrise":"_3Q0o","smartlineColorBeach":"_1hGh","festival":"_3nS2","mobileLink":"_3ZSZ","copyright":"_3w-8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/footer/style.css
// module id = 355
// module chunks = 9